import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05f3e2a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "worp" }
const _hoisted_2 = { class: "packet_bg_box" }
const _hoisted_3 = { class: "form_box" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "sw_fr"
}
const _hoisted_6 = { class: "form_title" }
const _hoisted_7 = { class: "form_title" }
const _hoisted_8 = { class: "form_title" }
const _hoisted_9 = {
  key: 1,
  class: "form_input"
}
const _hoisted_10 = { class: "input_num" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mar_l" }, "个", -1))
const _hoisted_12 = {
  key: 0,
  class: "input_num"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mar_l" }, "元", -1))
const _hoisted_14 = {
  key: 1,
  class: "input_num",
  style: {"width":"302px"}
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mar_l" }, "元", -1))
const _hoisted_16 = {
  key: 2,
  class: "form_input"
}
const _hoisted_17 = {
  class: "input_num",
  style: {"margin-right":"13px","border-radius":"2px"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mar_l" }, null, -1))
const _hoisted_19 = { class: "input_num" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mar_l" }, "个", -1))
const _hoisted_21 = { class: "item_img" }
const _hoisted_22 = { style: {"display":"flex"} }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text_l" }, [
  /*#__PURE__*/_createTextVNode(" 格式：jpg，png "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 大小：2M以内 ")
], -1))
const _hoisted_24 = {
  key: 3,
  class: "form_but"
}
const _hoisted_25 = {
  key: 4,
  class: "form_input"
}
const _hoisted_26 = { class: "input_num blessing" }
const _hoisted_27 = {
  class: "margin_left blessing",
  style: {"text-align":"center"}
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mini_text" }, " 观众需要回复口令抢红包", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = {
  key: 5,
  class: "form_input"
}
const _hoisted_31 = { class: "input_num blessing" }
const _hoisted_32 = { class: "margin_left blessing" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_34 = {
  key: 6,
  class: "form_input"
}
const _hoisted_35 = { class: "input_num blessing" }
const _hoisted_36 = { class: "margin_left blessing" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = {
  key: 7,
  class: "form_moeny"
}
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("单个红包最低0.3元(支付金额≧1元含3%"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("手续费)单个红包金额不能大于1000元")
], -1))
const _hoisted_42 = { class: "form_click" }
const _hoisted_43 = {
  key: 8,
  class: "form_text"
}
const _hoisted_44 = { class: "qr_box" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "收银台", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请使用微信扫码支付", -1))
const _hoisted_47 = { class: "qr_code" }
const _hoisted_48 = ["src"]

import { ref, computed, onUnmounted } from 'vue';
import { QuestionCircleFilled } from '@ant-design/icons-vue';
import CUpload from '@/components/CUpload.vue'; // 上传图片  组件
import { Button, Select, Input, InputNumber, Popover, message, Modal } from 'ant-design-vue';
import { redPacketBg } from '@/assets';
import http from '@/api';
import router from '@/router';
import { SelList, FileInfo } from './type';
import { useQRCode } from '@vueuse/integrations/useQRCode';

// `qrcode` will be a ref of data URL

export default /*#__PURE__*/_defineComponent({
  __name: 'RedPacket',
  props: {
    data: null
  },
  emits: ['click:close'],
  setup(__props: any, { emit }) {

const props = __props as {
  data: {
    packType: number;
    showPacket: boolean;
  };
};




const onBlack = () => {
  emit('click:close');
};
const aButton = Button;
const aSelect = Select;
const aTextarea = Input.TextArea;
const aInputNumber = InputNumber;
const aPopover = Popover;
const aModal = Modal;
const studioId = router.currentRoute.value.params.studioId;
const state = ref({
  quick: false,
  funValue: '竞答',
  resurrection: false,
  number: '',
  amount: '', //单个金额
  amountNum: '', //总金额
  title: '',
  questionId: '',
  textareaValue: '恭喜发财！大吉大利！',
});
const mainFrame = ref(true); // 主弹框 显示
const unexpectShow = ref(false); // 竞答红包弹窗 显示
const envelopesVeiw = ref(true); // 发红包页面 显示
// 主弹框和竞答弹窗 切换
const unexpectView = () => {
  unexpectShow.value = true;
  mainFrame.value = false;
};
const conUnusual = ref({
  variety1: false,
  cash: 0,
  variety2: false,
  variety3: false,
  variety4: false,
});
// 新建题库 选择器
const options = ref<SelList[]>([]);
const getQuestionList = () => {
  const data = {
    studio_id: studioId,
  };
  http.redpacket.getQuestionList({ params: data }).then((res) => {
    options.value = res.data.data ? res.data.data : [];
  });
};
const unexpectOut = () => {
  // unexpectShow.value = false;
  envelopesVeiw.value = true;
  // mainFrame.value = false;
  // console.log(props.dataType.pack, '0');
  switch (props.data.packType) {
    case 2:
      conUnusual.value.variety2 = true;
      break;
    case 3:
      conUnusual.value.variety3 = true;
      break;
    case 4:
      conUnusual.value.variety4 = true;
      break;
    default:
      conUnusual.value.variety1 = true; //竞答红包
      getQuestionList();
      break;
  }
};
unexpectOut();
const qrcodeMode = ref(false);
const adress = ref();
let timer: any = ref(0); //轮询订单定时器
const getWeCode = ref(0); //0 旧接口  1新接口

const wechat_pay_mode = () => {
  http.redpacket.wechat_pay_mode({ params: { studio_id: studioId } }).then((res) => {
    getWeCode.value = res.data.data;
  });
};
wechat_pay_mode();

// 微信扫码支付
const weChatPay = () => {
  const data = {
    order_no: orderNo.value,
    studio_id: studioId,
    pay_type: 2,
  };
  if (getWeCode.value) {
    http.redpacket.newWeChatScanPay({ order_no: orderNo.value, studio_id: studioId }).then((res) => {
      adress.value = res.data.data.code_url;
      qrcodeMode.value = true;
      timer.value = setInterval(() => {
        pollingOrder();
      }, 1000);
    });
  } else {
    http.redpacket.weChatPay({ params: data }).then((res) => {
      adress.value = res.data.data;
      qrcodeMode.value = true;
      timer.value = setInterval(() => {
        pollingOrder();
      }, 1000);
    });
  }
};

const pollingOrder = () => {
  const work = { order_no: orderNo.value };
  http.redpacket.pollingOrder({ params: work }).then((res) => {
    if (res.data.data.code != 40003) {
      if (res.data.code == 200) {
        clearInterval(timer.value);
        qrcodeMode.value = false;
        onBlack();
      }
    }
  });
};
const clearTime = () => {
  clearInterval(timer.value);
};
// 竞答红包 发送
const orderNo = ref(); //订单号
const goPay = ref();
const setContestPack = () => {
  const data = {
    studio_id: studioId,
    redpack_num: state.value.number,
    amount: state.value.amountNum,
    prize_title: state.value.title,
    prize_url: imageUrl.value,
    question_id: state.value.questionId,
    type: conUnusual.value.cash === 0 ? 1 : 2,
    resurrection: state.value.resurrection ? 1 : 0,
    convenient: state.value.quick ? 1 : 0,
    features: state.value.funValue,
  };
  http.redpacket
    .setContestPack(data)
    .then((res) => {
      goPay.value = res.data.data.go_pay;
      orderNo.value = res.data.data.order_no;
      if (conUnusual.value.cash === 0) weChatPay();
      else onBlack();
    })
    .catch((err) => {
      message.error(err.data.error);
    });
};
// 控制台--生成红包订单
const generateRedPacked = () => {
  // 【1普通红包 2拼手气红包 3口令红包】
  const type = ref();
  if (conUnusual.value.variety2 === true) {
    type.value = 3;
  } else if (conUnusual.value.variety3 === true) {
    type.value = 1;
  } else type.value = 2;
  let obj = {};
  if (conUnusual.value.variety3 === true) {
    obj = {
      studio_id: studioId,
      single_red_envelope_amount: state.value.amount, //总金额 or 单个金额
      envelope_num: state.value.number,
      command: state.value.textareaValue,
    };
  } else
    obj = {
      studio_id: studioId,
      envelope_money: state.value.amountNum, //总金额 or 单个金额
      envelope_num: state.value.number,
      command: state.value.textareaValue,
    };

  const data = {
    studio_id: studioId,
    type: type.value,
    amount: amountPay.value, //支付金额
    repack_info: JSON.stringify(obj),
  };
  http.redpacket
    .generateRedPacked(data)
    .then((res) => {
      orderNo.value = res.data.data;
      weChatPay();
    })
    .catch((err) => {
      message.error(err.data.error);
    });
};
const amountPay = ref();
const computerPay = computed(() => {
  return state.value.number && state.value.amount
    ? Number(state.value.number) * Number(state.value.amount) >= 1
      ? (Number(state.value.number) * Number(state.value.amount) * 1.03).toFixed(2)
      : (Number(state.value.number) * Number(state.value.amount)).toFixed(2)
    : 0;
});
const computerPay1 = computed(() => {
  return state.value.number && state.value.amountNum
    ? state.value.amountNum >= '1'
      ? (Number(state.value.amountNum) * 1.03).toFixed(2)
      : state.value.amountNum
    : 0;
});
// 塞钱进红包
const handEnvelope = () => {
  message.destroy();
  if (conUnusual.value.variety3 === true) {
    amountPay.value = computerPay.value;

    if (state.value.amount > '1000') {
      message.info('单个红包金额不能大于1000元(不含手续费)！');
    } else generateRedPacked();
  } else {
    amountPay.value = computerPay1.value;

    // 竞答红包
    if (conUnusual.value.variety1 === true) {
      if (conUnusual.value.cash === 0) {
        if (Number(state.value.amountNum) / Number(state.value.number) > 1000) {
          message.info('单个红包金额不能大于1000元(不含手续费)！');
        } else if (Number(state.value.amountNum) / Number(state.value.number) < 0.3)
          message.info('单个红包金额不能小于0.30元(不含手续费)！');
        else setContestPack();
      } else setContestPack();
    } else {
      if (Number(state.value.amountNum) / Number(state.value.number) > 1000) {
        message.info('单个红包金额不能大于1000元(不含手续费)！');
      } else if (Number(state.value.amountNum) / Number(state.value.number) < 0.3)
        message.info('单个红包金额不能小于0.30元(不含手续费)！');
      else generateRedPacked();
    }
  }
};
const stopRef = ref();

// 上传头像
const fileList = ref();
const imageUrl = ref('');
const imageId = ref();
const loading = ref(false);
const uploadImage = (info: FileInfo) => {
  if (info.file?.response?.code === 200) {
    imageUrl.value = info.file?.response?.data.url;
    imageId.value = info.file?.response?.data.id;
  }
  if (info.file.status === 'uploading') {
    loading.value = true;
  } else loading.value = false;
};
const imageDel = () => {
  imageUrl.value = '';
  imageId.value = '';
};
// 总金额
const focusChange = (num: number) => {
  if (num === 1) state.value.amount = state.value.amount ? state.value.amount : '0.3'; //单个金额
  if (num === 2)
    state.value.amountNum = state.value.number
      ? state.value.amountNum
        ? state.value.amountNum
        : (0.3 * Number(state.value.number)).toFixed(2)
      : '0.3'; //总金额
};

onUnmounted(() => {
  clearTime();
});

const qrcode = useQRCode(adress, {
  margin: 3,
});

return (_ctx: any,_cache: any) => {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_select_option = _resolveComponent("a-select-option")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _unref(redPacketBg),
          class: "packet_bg"
        }, null, 8, _hoisted_4),
        _createElementVNode("div", {
          ref_key: "stopRef",
          ref: stopRef,
          class: "form"
        }, [
          (conUnusual.value.variety1 === true)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createTextVNode("复活开关："),
                _createVNode(_component_a_switch, {
                  checked: state.value.resurrection,
                  "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((state.value.resurrection) = $event))
                }, null, 8, ["checked"])
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", {
            class: _normalizeClass(["form_title", conUnusual.value.cash === 1 ? 'form_title_min' : ''])
          }, " 竞答红包 ", 2), [
            [_vShow, conUnusual.value.variety1 === true]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_6, "口令红包", 512), [
            [_vShow, conUnusual.value.variety2 === true]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_7, "定额红包", 512), [
            [_vShow, conUnusual.value.variety3 === true]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_8, "拼手气红包", 512), [
            [_vShow, conUnusual.value.variety4 === true]
          ]),
          (conUnusual.value.cash === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createTextVNode(" 红包个数："),
                  _createVNode(_unref(aInputNumber), {
                    value: state.value.number,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((state.value.number) = $event)),
                    class: "guest_in",
                    min: 1
                  }, null, 8, ["value"]),
                  _hoisted_11
                ]),
                (conUnusual.value.variety3 === true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createTextVNode(" 单个金额："),
                      _createVNode(_unref(aInputNumber), {
                        value: state.value.amount,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((state.value.amount) = $event)),
                        class: "guest_in",
                        min: 0.3,
                        step: 0.1,
                        onFocus: _cache[3] || (_cache[3] = ($event: any) => (focusChange(1)))
                      }, null, 8, ["value", "min", "step"]),
                      _hoisted_13
                    ]))
                  : _createCommentVNode("", true),
                (conUnusual.value.variety3 !== true && conUnusual.value.cash === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createTextVNode(" 总金额："),
                      _createVNode(_unref(aInputNumber), {
                        value: state.value.amountNum,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((state.value.amountNum) = $event)),
                        class: "guest_in",
                        min: 0.3,
                        step: 0.1,
                        onFocus: _cache[5] || (_cache[5] = ($event: any) => (focusChange(2)))
                      }, null, 8, ["value", "min", "step"]),
                      _hoisted_15
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (conUnusual.value.cash === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createTextVNode(" 奖励名称："),
                  _createVNode(_component_a_input, {
                    value: state.value.title,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((state.value.title) = $event)),
                    class: "guest_in"
                  }, null, 8, ["value"]),
                  _hoisted_18
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createTextVNode(" 红包个数："),
                  _createVNode(_unref(aInputNumber), {
                    value: state.value.number,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((state.value.number) = $event)),
                    class: "guest_in",
                    min: 1
                  }, null, 8, ["value"]),
                  _hoisted_20
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createTextVNode(" 奖品图片： "),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(CUpload, {
                      "file-list": fileList.value,
                      "image-name": imageUrl.value,
                      loading: loading.value,
                      "handle-change": (info) => uploadImage(info),
                      "upload-text": false,
                      "click-stop": imageDel,
                      mask: false,
                      class: "input_num_img"
                    }, null, 8, ["file-list", "image-name", "loading", "handle-change"]),
                    _hoisted_23
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (conUnusual.value.variety1 === true)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _withDirectives(_createElementVNode("p", null, [
                  _createTextVNode("当前为现金红包，"),
                  _createElementVNode("span", {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (conUnusual.value.cash = 1))
                  }, "改为自定义红包")
                ], 512), [
                  [_vShow, conUnusual.value.cash === 0]
                ]),
                _withDirectives(_createElementVNode("p", null, [
                  _createElementVNode("span", {
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (conUnusual.value.cash = 0))
                  }, "改为现金红包"),
                  _createTextVNode("，当前为自定义红包")
                ], 512), [
                  [_vShow, conUnusual.value.cash === 1]
                ]),
                _createVNode(_component_router_link, {
                  to: `/market/${_unref(studioId)}/competitive_red_envelope`,
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(aButton), {
                      class: "create_but",
                      target: "block"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 新建题库 ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["to"]),
                _createVNode(_unref(aSelect), {
                  value: state.value.questionId,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((state.value.questionId) = $event)),
                  "get-popup-container": () => stopRef.value,
                  class: "but_sel"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (item) => {
                      return _withDirectives((_openBlock(), _createBlock(_component_a_select_option, {
                        key: item.id,
                        value: item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"])), [
                        [_vShow, options.value.length > 0]
                      ])
                    }), 128)),
                    (options.value.length === 0)
                      ? (_openBlock(), _createBlock(_component_a_select_option, {
                          key: 0,
                          value: "无数据",
                          disabled: "true"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("无数据")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["value", "get-popup-container"])
              ]))
            : _createCommentVNode("", true),
          (conUnusual.value.variety2 === true)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createTextVNode(" 设置口令"),
                    _hoisted_28,
                    _hoisted_29,
                    _createVNode(_unref(aTextarea), {
                      value: state.value.textareaValue,
                      "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((state.value.textareaValue) = $event)),
                      placeholder: "恭喜发财！大吉大利",
                      "auto-size": { minRows: 4, maxRows: 4 },
                      class: "blessing_w"
                    }, null, 8, ["value"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (conUnusual.value.variety3 === true)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createTextVNode(" 祝福语"),
                    _hoisted_33,
                    _createVNode(_unref(aTextarea), {
                      value: state.value.textareaValue,
                      "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((state.value.textareaValue) = $event)),
                      placeholder: "恭喜发财！大吉大利",
                      "auto-size": { minRows: 4, maxRows: 4 },
                      maxlength: 10,
                      showCount: "",
                      class: "blessing_w"
                    }, null, 8, ["value"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (conUnusual.value.variety4 === true)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createTextVNode(" 祝福语"),
                    _hoisted_37,
                    _createVNode(_unref(aTextarea), {
                      value: state.value.textareaValue,
                      "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((state.value.textareaValue) = $event)),
                      placeholder: "恭喜发财！大吉大利",
                      "auto-size": { minRows: 4, maxRows: 4 },
                      maxlength: 10,
                      showCount: "",
                      class: "blessing_w"
                    }, null, 8, ["value"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (conUnusual.value.cash !== 1)
            ? (_openBlock(), _createElementBlock("p", _hoisted_38, [
                (conUnusual.value.variety3 === true)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_39, " ￥" + _toDisplayString(_unref(computerPay)) + "元", 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_40, "￥ " + _toDisplayString(_unref(computerPay1)) + "元", 1)),
                _createTextVNode("   "),
                (conUnusual.value.cash !== 1)
                  ? (_openBlock(), _createBlock(_unref(aPopover), {
                      key: 2,
                      placement: "right"
                    }, {
                      content: _withCtx(() => [
                        _hoisted_41
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_unref(QuestionCircleFilled), { style: {"font-size":"16px"} })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_42, [
            (conUnusual.value.cash === 1)
              ? (_openBlock(), _createBlock(_unref(aButton), {
                  key: 0,
                  size: "large",
                  disabled: state.value.number && imageUrl.value ? false : true,
                  class: _normalizeClass([{ checking: !(state.value.number && imageUrl.value) }, "form_moeny_but"]),
                  onClick: handEnvelope
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("塞奖进红包")
                  ]),
                  _: 1
                }, 8, ["disabled", "class"]))
              : (_openBlock(), _createBlock(_unref(aButton), {
                  key: 1,
                  size: "large",
                  class: _normalizeClass(["form_moeny_but", { checking: !((state.value.amount || state.value.amountNum) && state.value.number) }]),
                  disabled: (state.value.amount || state.value.amountNum) && state.value.number ? false : true,
                  onClick: handEnvelope
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("塞钱进红包")
                  ]),
                  _: 1
                }, 8, ["disabled", "class"]))
          ]),
          (conUnusual.value.cash === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_43, "观众领取的红包将自动存入微信零钱"))
            : _createCommentVNode("", true),
          _createVNode(_unref(aModal), {
            visible: qrcodeMode.value,
            "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((qrcodeMode).value = $event)),
            width: "240px",
            centered: "",
            footer: null,
            closable: false,
            onCancel: clearTime,
            "get-container": () => stopRef.value
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_44, [
                _hoisted_45,
                _hoisted_46,
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("img", {
                    src: _unref(qrcode),
                    alt: "QR Code"
                  }, null, 8, _hoisted_48)
                ])
              ])
            ]),
            _: 1
          }, 8, ["visible", "get-container"])
        ], 512)
      ])
    ])
  ]))
}
}

})